import { Component } from 'react';
import ServiceFeeService from '../Services/ServiceFeeService';
import moneyHelper from '../Helpers/moneyHelper';

class GetActualLineItemValueText extends Component {

    state = {
        text: ""
    }

    componentDidMount() {
        ServiceFeeService.GetActualLineItemValue(this.props.OpportunityId)
            .then(result => {
                let value = moneyHelper.toMoneyFormat(result.value, this.props.OpportunityCurrency)
                this.setState({ text: value })
            })
            .catch(error => this.setState({ text: "Not found" }));
    }

    render() {
        return (this.state.text);
    }
}

export default GetActualLineItemValueText; 
